import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { ISetting } from '@/types/set.d';

@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '配置 - 模态框 -',
    component: 'set/components/bModal',
  };

  public form: any = {
    sort: 0,
  }

  public loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    title: [
      { required: true, message: '名称不能为空' },
    ],
    initType: [
      { required: true, message: '类别不能为空' },
    ],
    visible: [
      { required: true, message: '是否显示不能为空' },
    ],
    remark: [
      { required: true, message: '难易程度不能为空' },
    ],
    key: [
      { required: true, message: '配置不能为空' },
    ],
    value: [
      { required: true, message: '配置值不能为空' },
    ],
    effectiveStatus: [
      { required: true, message: '客户状态不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
